// @flow

import { type Country } from '@tectonics/prs/country';

const NOT_NUMBERS = /[^0-9]+/ug;

export function getPhoneNumberNormalizer(country: Country): ?string => string {

  return (phoneNumber: ?string) => {

    if (!phoneNumber)
      return '';

    const onlyNumbersPhoneNumber = phoneNumber.replace(NOT_NUMBERS, '');

    switch (country) {
      case 'br':
        return onlyNumbersPhoneNumber.substr(0, 13);

      case 'ar':
      case 'bo':
      case 'cl':
      case 'co':
      case 'ec':
      case 'mx':
      case 'pe':
      case 'uy':
      case 'py':
      case 'pa':
      case 'cr':
      case 'sv':
      case 'gt':
      case 'do':
      case 'za':
      case 'ke':
      case 'ng':
      case 'in':
      case 'tz':
      case 'ug':
      case 'zm':
      case 'eg':
      case 'gh':
      case 'jm':
        return onlyNumbersPhoneNumber.substr(0, 20);

      default:
        throw new Error(`PhoneNumberNormalizer: not implemented for country ${country}`);
    }
  };
}
